import "./App.css";
import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/Sidebar";
import Footer from "./components/Footer/Footer";
import { Navigate, Route, Routes } from "react-router-dom";
import UsersContainer from "./components/Users/UsersContainer";
import ProfileContainerWithApi from "./components/Profile/MainContainer";
import LoginContainerAPI from "./components/Login/LoginContainer";
import RegisterContainerAPI from "./components/Register/RegisterContainer";
import PreLogin from "./components/Login/PreLogin";
import React from "react";
import { loginSuccess } from "./redux/login-reducer";
import axios from "axios";
import SettingsContainer from "./components/Settings/SettingsContainer";
import OtherProfileContainerWithApi from "./components/OtherProfile/OtherProfileContainer";
import NewsContainerWithRedux from "./components/News/NewsContainer";
import ChatContainer from "./components/Chat/ChatContainer";
import { setErrorMessage } from "./redux/error-reducer";
import ErrorCatcherContainer from "./components/common/ErrorCatcher/ErrorCatcher";
import { connect } from "react-redux";
import { Admin, AppBar, Layout, Resource } from "react-admin";
import { dataProvider } from "./components/admin/dataProvider";
import { PostList } from "./components/admin/posts";
import UserList from "./components/admin/users";
import ChatList from "./components/admin/chats";
import LogOutContainer from "./LogOut";
import { createTheme } from "@mui/material";
import PostShow from "./components/admin/PostShow";

const MyAppBar = (props) => (
  <AppBar {...props}>
    <LogOutContainer />
  </AppBar>
);

const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} />;

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

class App extends React.Component {
  componentDidMount() {
    this.fetchToken();
  }

  fetchToken() {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      axios
        .post("https://converso-social-network-api.onrender.com/protected", {
          token: storedToken,
        })
        .then((response) => {
          const { token, username, userId } = response.data;
          this.props.loginSuccess({ token, username, userId });
        })
        .catch((error) => {
          console.error(error);
          this.props.setErrorMessage(
            error.response.data.message,
            error.response.status
          );
        });
    }
  }
  render() {
    const { isAuthenticated } = this.props;
    const role = localStorage.getItem("role");
    if (role === "admin" && isAuthenticated) {
      return (
        <Admin layout={MyLayout} dataProvider={dataProvider} theme={theme}>
          <Resource name="posts" list={PostList} show={PostShow} />
          <Resource name="users" list={UserList} />
          <Resource name="chats" list={ChatList} />
        </Admin>
      );
    }

    return (
      <div className="App">
        {this.props.errorMessage ? <ErrorCatcherContainer /> : <></>}
        <Header />
        {isAuthenticated ? (
          <>
            <Sidebar />
            <div className="route_side_bar">
              <Routes>
                <Route
                  path="/profile/:userId"
                  element={<ProfileContainerWithApi />}
                />
                <Route path="/profile/" element={<ProfileContainerWithApi />} />
                <Route path="/dialogs/*" element={<ChatContainer />} />
                <Route path="/users/" element={<UsersContainer />} />
                <Route path="/news" element={<NewsContainerWithRedux />} />
                <Route path="/settings" element={<SettingsContainer />} />
                <Route
                  path="/user-profile/:userId"
                  element={<OtherProfileContainerWithApi />}
                />
                <Route path="*" element={<Navigate to="/profile" />} />
              </Routes>
            </div>
          </>
        ) : (
          <>
            <PreLogin />
            <Routes>
              <Route path="/login" element={<LoginContainerAPI />} />
              <Route path="/registration" element={<RegisterContainerAPI />} />
            </Routes>
            <Footer />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.loginInfo.isAuthenticated,
  role: state.loginInfo.role,
  errorMessage: state.errorInfo.errorMessage,
});

const AppContainer = connect(mapStateToProps, {
  setErrorMessage,
  loginSuccess,
})(App);
export default AppContainer;
